/* global axios */
import ApiClient from './ApiClient';

class MetaLeadIntegrationsAPI extends ApiClient {
  constructor() {
    super('meta/lead_integrations', { accountScoped: true });
  }

  getPages(omniauthToken) {
    return axios.post(`${this.url}/pages`, { omniauth_token: omniauthToken });
  }

  syncForms(id) {
    return axios.post(`${this.url}/${id}/sync_forms`);
  }

  // `page` e opcional de proposito: sem ele o backend devolve a primeira
  // pagina, que e exatamente o que a chamada sem paginacao devolvia antes.
  getEvents(id, page) {
    return axios.get(`${this.url}/${id}/events`, { params: { page } });
  }

  reprocessEvent(id, eventId) {
    return axios.post(`${this.url}/${id}/events/${eventId}/reprocess`);
  }

  replayEventAction(id, eventId, stepKey) {
    return axios.post(`${this.url}/${id}/events/${eventId}/replay_action`, {
      step_key: stepKey,
    });
  }
}

export default new MetaLeadIntegrationsAPI();
